import { Button, TextField, Box, CircularProgress } from '@mui/material';
import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router';
import { isEmpty } from 'lodash';
import { Link } from 'react-router';

import apiFunctions from '../../api';

import { Pages } from '../../types/pages';
import { requestLogin, tooManyRequests } from '../../types/api';
import { useAuth } from '../../utility/auth';
import { LastLoginUsernameKey, UnauthorizedErrorKey } from '../../types/localStorage';

import { RetrieveFromLocalStorage, InsertToLocalStorage, DeleteFromLocalStorage } from '../../utility/localStorage';

import './index.css';

const Login = () => {
  const auth = useAuth();
  const location: any = useLocation();

  const [username, setUsername] = useState<string>(RetrieveFromLocalStorage(LastLoginUsernameKey) || '');
  const [errorUsername, setErrorUsername] = useState<boolean>(false);
  const [tooMany, setTooMany] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [sentCode, setSentCode] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(RetrieveFromLocalStorage(UnauthorizedErrorKey));

  let from = location.state?.from?.pathname || '/';

  useEffect(() => {
    let subscribed = true;
    const requestLink = async () => {
      await apiFunctions.apiPost(requestLogin, { username: username }).then((res) => {
        if (subscribed) {
          if (res === tooManyRequests) {
            setTooMany(true);
          } else {
            setSentCode(true);
            setErrorMessage('');
            DeleteFromLocalStorage(UnauthorizedErrorKey);
            InsertToLocalStorage(LastLoginUsernameKey, username);
          }

          setLoading(false);
        }
      });
    };

    if (loading) {
      requestLink();
    }

    return () => {
      subscribed = false;
    };
  }, [loading, auth, username]);

  useEffect(() => {
    document.getElementById('Username')?.focus();
  });

  const handleLoginLinkRequest = () => {
    setErrorUsername(false);
    let user = username.trim();
    if (user.indexOf('@e-hps.com') !== -1) {
      user = user.substring(0, user.indexOf('@e-hps.com'));
      setUsername(user);
    }
    if (user.length > 0 && user.length < 100 && !isEmpty(user)) {
      setLoading(true);
    } else setErrorUsername(true);
  };

  if (loading) return <CircularProgress />;
  else if (sentCode) return <Navigate to={Pages.Start} state={{ sent: true, from: from }}></Navigate>;
  else if (!auth.user)
    return (
      <Box className="flex-form">
        <TextField
          value={username}
          error={errorUsername}
          sx={{ width: '300px' }}
          helperText={errorUsername && 'Invalid input.'}
          label="Username"
          onChange={(e: any) => setUsername(e.target.value)}
          onKeyDown={(e: any) => {
            if (e.code === 'Enter') handleLoginLinkRequest();
          }}
          id="Username"
          variant="outlined"
        />
        <Button id="CodeRequestButton" variant="contained" disabled={tooMany} onClick={() => handleLoginLinkRequest()}>
          Request Code
        </Button>
        <Link to={Pages.Start}>Already have a code?</Link>
        {tooMany && (
          <Box color="warning.main" sx={{ padding: '5px' }}>
            Too many requests
          </Box>
        )}
        {errorMessage && (
          <Box color="warning.main" sx={{ padding: '5px' }}>
            {errorMessage}
          </Box>
        )}
      </Box>
    );
  else return <Navigate to={from} />;
};

export default Login;
